import * as Yup from "yup";

/**
 * Business Rule:
 * Duplicate rows (same Department + Job Title) are NOT allowed.
 */
const noDuplicateRows = (entries) => {
  if (!entries || entries.length < 2) return true;
  const seen = new Set();

  for (const row of entries) {
    // Only validate complete pairs to avoid flagging empty rows immediately
    if (row.department && row.jobTitle) {
      const key = `${row.department}-${row.jobTitle}`;
      if (seen.has(key)) return false;
      seen.add(key);
    }
  }
  return true;
};

export const PayrollValidationSchema = Yup.object().shape({
  /* =========================
      HEADER FIELDS
     ========================= */
  corporation: Yup.object()
    .required("Corporation Name is required")
    .test("is-valid-corporation", "Corporation Name is required", (value) => {
      return value && value.corpValue !== "" && value.corpName !== "--Select--";
    }),

  itemName: Yup.string()
    .trim()
    .required("Item Name is required"),

  itemType: Yup.string()
    .required("Item Type is required"),

  /* =========================
      WAGES RULES
     ========================= */
  wageType: Yup.string().when("itemType", {
    is: "wages",
    then: (schema) => schema.required("Wage Type is required."),
    otherwise: (schema) => schema.notRequired(),
  }),

  /**
   * NOTE: If your wageType state stores an ID, you cannot check 
   * for the string "Hourly wage". If you need to enforce Pay Type 
   * for specific wages, it is safer to require it for ALL wages 
   * or pass the wage object to check properties.
   */
  wageTypeName: Yup.string(),

  payType: Yup.string().when(["itemType", "wageTypeName"], {
    is: (itemType, wageTypeName) => itemType === "wages" ,
    then: (schema) => schema.required("Pay Type is required."),
    otherwise: (schema) => schema.notRequired(),
  }),

  // percentage: Yup.string().when(["itemType", "wageTypeName"], {
  //   is: (itemType, wageTypeName) => itemType === "wages" && (wageTypeName === "Commission" || wageTypeName === "Bonus"),
  //   then: (schema) => schema.required("Percentage is required."),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  /* =========================
      GRID VALIDATION
     ========================= */
  entries: Yup.array()
    .test(
      "no-duplicate-rows",
      "Duplicate row detected. Each Department/Job Title combination must be unique.",
      noDuplicateRows
    )
    .test(
      'job-title-for-wages',
      'Job Title is required for Wages.', // This is a fallback message.
      function (entries) {
        const { itemType } = this.parent;
        if (itemType !== 'wages' || !entries) {
          return true;
        }

        // Find the index of the first entry that is missing a jobTitle
        const invalidIndex = entries.findIndex(entry => !entry.jobTitle);

        // If an invalid entry is found, create an error pointing to that specific field
        if (invalidIndex !== -1) {
          return this.createError({
            path: `entries[${invalidIndex}].jobTitle`,
            message: 'Job Title is required for Wages.'
          });
        }
        return true;
      }
    )
    .of(
      Yup.object().shape({
        department: Yup.string()
          .required("Department is required"),

        jobTitle: Yup.string().nullable(),

        expenseCoa: Yup.string().required("Expense COA is required"),





        payableCoa: Yup.string().notRequired(),
      })
    ),
});





export const validationSchema = Yup.object({
  ssn: Yup.string()
    .matches(/^\d{3}-\d{2}-\d{4}$/, "SSN must be 9 digits (XXX-XX-XXXX)")
    .required("SSN is required")
});
